import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import ActionMenu from '@/components/actionmenu';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ReportDialog } from '@/components/reportbutton';

const PostVisitorMenu = ({ post, chatBusy, onContact, adminItems = [], adminBusy = false }) => {
  const { isAuthenticated, userInfo, sessionVersion } = useSelector(state => state.user);
  const navigate = useNavigate();
  const [reportTarget, setReportTarget] = useState(null);
  useEffect(() => { setReportTarget(null); }, [isAuthenticated, userInfo?.id, sessionVersion, post.id, post.user?.id]);
  const report = target => {
    if (!isAuthenticated) { message.warning('请先登录后举报'); navigate('/login'); return; }
    setReportTarget(target);
  };
  const owner = userInfo?.id != null && String(userInfo.id) === String(post.user?.id);
  const items = [
    ...adminItems,
    ...(adminItems.length && !owner ? [{ type: 'divider' }] : []),
    ...(!owner ? [
      { key: 'contact', label: '联系作者', disabled: chatBusy, onClick: onContact },
      { type: 'divider' },
      { key: 'report-post', label: '举报帖子', disabled: !post.id, onClick: () => report('post') },
      { key: 'report-user', label: '举报用户', disabled: !post.user?.id, onClick: () => report('user') },
    ] : []),
  ];
  return <>
    <ActionMenu label="更多操作" placement="bottomRight" items={items} disabled={chatBusy || adminBusy}
      buttonProps={{ className: 'post-detail-visitor-menu', loading: chatBusy || adminBusy }} />
    {reportTarget && <ReportDialog targetType={reportTarget} targetId={reportTarget === 'post' ? post.id : post.user?.id}
      authorId={post.user?.id} open onClose={() => setReportTarget(null)} />}
  </>;
};

export default PostVisitorMenu;
